import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Heart } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function VoteButton({ candidate, onVoted, size = "md", className = "", label = "Vote Now" }) {
  const [loading, setLoading] = useState(false);

  const vote = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/vote", { candidate_id: candidate.id });
      toast.success(`Vote counted for ${candidate.name}!`, {
        description: `${data.remaining_today} vote${data.remaining_today === 1 ? "" : "s"} remaining today.`,
      });
      onVoted?.(data.votes);
    } catch (e) {
      const status = e.response?.status;
      toast.error(status === 429 ? "Daily limit reached" : "Could not record vote", {
        description: formatApiError(e.response?.data?.detail) || e.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const sizes = {
    sm: "px-4 py-2 text-xs",
    md: "px-6 py-3 text-sm",
    lg: "px-8 py-4 text-base",
  };

  return (
    <button
      data-testid={`vote-button-${candidate.slug}`}
      onClick={vote}
      disabled={loading}
      className={`btn-gold inline-flex items-center justify-center gap-2 disabled:opacity-70 ${sizes[size]} ${className}`}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Heart className="h-4 w-4" />}
      {label}
    </button>
  );
}
